module.exports = __webpack_public_path__ + "media/images/gallery/2-6765f5854a2ce6206cdf9b115e9bd256.jpg";